// extracted by mini-css-extract-plugin
export var clickThrough = "_yx-2";
export var fallback = "_yx-5";
export var frame = "_yx-3";
export var frameCell = "_yx-1";
export var overlay = "_yx-4";
export var wrapper = "_yx-0";